import dayjs from 'dayjs';

export enum DateInputView {
  Day,
  Year,
  Month,
}

export type PickerViewState = {
  year: number;
  month: number;
  view: DateInputView;
  canShowNext: boolean;
  canShowPrev: boolean;
};

export type PickerConfig = {
  yearsCount?: number;
  minDate?: dayjs.ConfigType;
  maxDate?: dayjs.ConfigType;
};
